import React from "react";
import Styles from "./Container.module.scss";

const Container = props => {
  return <div className={`${Styles.container} ${props.growHeight ? Styles.growHeight : ""}`}>{props.children}</div>;
};

export default Container;
